<script lang="ts" generics="TValues, TValue extends unknown">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { cx } from '$lib/utils/cx.js';
    import type { ChangeEvent } from '$lib/utils/types.js';
    import type { HTMLTextareaAttributes } from 'svelte/elements';
    import { createTextareaAutosize } from '$lib/utils/textareaAutosize';

    export let rows: number | undefined | null = null;
    export let autoresize: boolean = false;
    export let autofocus: boolean = false;
    export let onKeyPress: HTMLTextareaAttributes['on:keypress'] = undefined;
    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;
    export let id: string | null = null;

    export let placeholder: HTMLTextareaAttributes['placeholder'] = undefined;

    export let toText: (value: TValue) => string | null | undefined;
    export let fromText: (string: string) => TValue;

    let className: string = '';
    export { className as class };

    export let inputRef: HTMLTextAreaElement | null = null;

    const { useTextareaAutosize } = createTextareaAutosize();

    $: _useTextareaAutosize = autoresize ? useTextareaAutosize : () => {};

    function onInput(event: ChangeEvent<HTMLTextAreaElement>) {
        const v = event.currentTarget.value;
        form.dispatch(form.actions().changeValue(fromText(v), field));
    }

    function onBlur() {
        form.dispatch(form.actions().blur(field));
    }

    function onFocus() {
        form.dispatch(form.actions().focus(field));
    }

    $: v = form.stores().fieldValue(field);
    $: nbSubmits = form.stores().nbSubmits();
    $: isAlreadyBlur = form.stores().isAlreadyBlur(field);
    $: hasAnyErrors = form.stores().hasFieldAnyErrors(field);
    $: fieldId = form.getFieldId(field);
    $: valueText = toText($v) ?? '';
</script>

<!-- svelte-ignore a11y-autofocus -->
<textarea
    bind:this={inputRef}
    id={id ?? fieldId}
    class={cx(
        'control-form',
        ($nbSubmits > 0 || $isAlreadyBlur) && $hasAnyErrors
            ? 'control-form--invalid'
            : '',
        className,
    )}
    use:_useTextareaAutosize
    {rows}
    {autofocus}
    {placeholder}
    on:focus={onFocus}
    on:blur={onBlur}
    on:input={onInput}
    on:keypress={onKeyPress}>{valueText}</textarea
>
